import { useEffect } from "react";
import { useAxiosPost } from "../../axios";
import { useLocation } from "react-router-dom";

export const getActiveKeywords = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("keyword") ?? "";
};

const updateDraftPage = async (formDraftId: string) => {
  try {
    await useAxiosPost(`/trackers/cart-page/${formDraftId}`, {
      page: window.location.pathname,
      currentKeywords: getActiveKeywords(),
      currentScroll: window.scrollY ?? 0,
    });
  } catch (e) {
    //
  }
};

export const usePage = () => {
  const location = useLocation();
  // add a listener to the window object to track the page view
  // when the user navigates to a new page, call the function to track the page view
  useEffect(() => {
    const formDraftId = localStorage.getItem("tw-form-draft-id") ?? sessionStorage.getItem("tw-form-draft-id");
    if (formDraftId) {
      updateDraftPage(formDraftId);
    }
  }, [location?.pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      const formDraftId = localStorage.getItem("tw-form-draft-id") ?? sessionStorage.getItem("tw-form-draft-id");
      if (formDraftId && !window.location.pathname.includes("disposal")) {
        updateDraftPage(formDraftId);
      }
    }, 50000);
    return () => clearInterval(interval);
  }, []);
};
